import { Col, Row } from 'antd';

import SkillBar from './SkillBar';
import Title from './Title';

interface TestSkillsProps {
  motivational?: number;
  social?: number;
  mental?: number;
}

const TestSkills: React.FC<TestSkillsProps> = ({ mental, motivational, social }) => {
  return (
    <Col>
      <Title title="Habilidades" />
      <Row gutter={[8, 8]}>
        <Col span={8}>
          <SkillBar
            name="Mental"
            color="#018b97"
            grade={mental}
            average={36.98}
            tooltipText="Mede o raciocínio ou a capacidade mental para assimilar novas informações, formular conclusões e identificar padrões. Está relacionado com a velocidade de aprendizado pois mede a habilidade de um indivíduo de realizar operações mentais."
          />
        </Col>
        <Col span={8}>
          <SkillBar
            name="Social"
            color="#00CC85"
            grade={social}
            average={44.49}
            tooltipText='Esse teste mede habilidades interpessoais, entende como a pessoa se comporta em diferentes contextos sociais e como lida com eles de maneira eficaz. Mede o "bom senso social" e não tem correlação com ser introvertido ou extrovertido.'
          />
        </Col>
        <Col span={8}>
          <SkillBar
            name="Motivacional"
            color="#A44A3F"
            grade={motivational}
            average={55.42}
            tooltipText="Serve para entender a postura motivacional de um indivíduo, se ele enfrenta o risco e se move em busca do sucesso ou se tem maior tendência a “evitar o fracasso”."
          />
        </Col>
      </Row>
    </Col>
  );
};

export default TestSkills;
